import React, { useState, useEffect, useContext } from 'react'
import {
    Container,
} from "reactstrap"

import { withRouter } from 'react-router-dom'
import EditForm from './components/EditForm'
import ApiService from '../../data/services/ApiService'
import { GeneralContext } from '../../context/'

const Edit = (props) => {
    const generalContext = useContext(GeneralContext)
    const { setLoading, setBreadcrumb } = generalContext
    const [product, setProduct] = useState()

    useEffect(() => {
        setBreadcrumb({
            icon: '',
            parent: `Productos`,
            parentLink: '/products',
            item: `Editar Producto`
        })

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        (async () => {
            const id = props.match.params.id
            await fetchProduct(id)
        })()

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const fetchProduct = async (id) => {
        setLoading(true)

        try {
            const response = await ApiService.getProductById(id)
            const { product } = response.data

            setProduct(product)
        } catch (error) {
            console.log(error)
            setLoading(false)
        } finally {
            setLoading(false)
        }
    }

    return(
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    {product && (
                        <EditForm product={product} />
                    )}
                </Container>
            </div>
        </React.Fragment>
    )
}

export default withRouter(Edit)
